import React from 'react'
import {ArrowLeft} from "lucide-react";
import {Link} from "react-router-dom";

const ExitBlogPostPage = () => {
    return (
        <Link
            to="/sharing-blog"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary-cyan transition-colors mb-8"
        >
            <ArrowLeft size={16} />
            Quay lại danh sách
        </Link>
    )
}
export default ExitBlogPostPage
